// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section__FeatureGrid-module--ekLfI {
    padding: var(--space-2xl) var(--space-md);
}

.inner__FeatureGrid-module--G16pR {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: var(--space-lg);
}

.heading__FeatureGrid-module--xSyRJ {
    margin: 0;
    font-size: var(--home-text-heading);
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1;
}

.grid__FeatureGrid-module--bpRuW.grid__FeatureGrid-module--bpRuW {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(250px, 100%), 1fr));
    grid-auto-rows: minmax(180px, auto);
    gap: var(--space-sm);
    margin: 0;
    padding: 0;
    list-style: none;
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/FeatureGrid.module.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sEAAsE;IACtE,mCAAmC;IACnC,oBAAoB;IACpB,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB","sourcesContent":[".section {\n    padding: var(--space-2xl) var(--space-md);\n}\n\n.inner {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-lg);\n}\n\n.heading {\n    margin: 0;\n    font-size: var(--home-text-heading);\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    line-height: 1;\n}\n\n.grid.grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(min(250px, 100%), 1fr));\n    grid-auto-rows: minmax(180px, auto);\n    gap: var(--space-sm);\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `section__FeatureGrid-module--ekLfI`,
	"inner": `inner__FeatureGrid-module--G16pR`,
	"heading": `heading__FeatureGrid-module--xSyRJ`,
	"grid": `grid__FeatureGrid-module--bpRuW`
};
export default ___CSS_LOADER_EXPORT___;
